export const URL = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}([-a-zA-Z0-9@:%_+.~#?&//=()]*)?$/;

export const ALPHANUMERIC = /[^a-zA-Z0-9 ]/g;
